import { RESET_ACTION, CHINESE_VEHICLE_ACTION } from '../staticData';

export function chineseVehicleReducer(state: any[], action: any) {
  switch (action.type) {
    case CHINESE_VEHICLE_ACTION.set:
      return action.payload;

    case RESET_ACTION:
      return {};

    default:
      throw new Error();
  }
}
